import React from 'react';
import Header, { HeaderLeft, HeaderRight } from '../../layout/Header/Header';
import Button from '../../components/bootstrap/Button';

const DashboardHeader = () => {
    return (
        <Header>
            <HeaderLeft>
                <div className='d-flex'>
                    <h5 className='header-welcome'>
                        Welcome to Liiftsocial, Fenil
                    </h5>
                </div>
            </HeaderLeft>
            <HeaderRight>
                <div className='d-flex'>
                    <Button color='primary' icon='Star'>
                        Trial more features
                    </Button>
                    <a href='/subscription'>
                        <Button
                            className='gradient-btn-custom'
                            style={{ marginLeft: '10px' }}>
                            Start my subscription
                        </Button>
                    </a>
                </div>
            </HeaderRight>
        </Header>
    );
};

export default DashboardHeader;
